/*
* Set up the necessary wiring to load the FV library.
* */


/*
* Set webpack config's publicpath on run time.
* At time of the html parse, this will always be the last script on the page.
* the path with the assets is now always the same as the one containing the js file
* (barring dynamic insertion of the library on page b/f other script tags).
* Note: cannot set publicpath on runtime if using the extract text plugin !!!
* This would break the links to resources like 'icons' linked to in external css files.
* here, working since we assume all assets are in the viewer.js directory and
* Webpack's public path is set to this directory on build.
* */
var scripts = document.getElementsByTagName("script");
var src = scripts[scripts.length - 1].getAttribute("src");
__webpack_public_path__ = src.substr(0, src.lastIndexOf("/") + 1);

/*
 * Base styling.
 *  Require once -- wrap loader will require by ref in less to resolve variables.
 * */
require('../../../stylesheets/viewerBase.less');

var util = require('./util');

/*
 * Establish some polyfills for IE8.
 * Note: if testing IE8 must test in browser and document mode in the VM.
* */
if (util.isIE8()) {
    require('../../polyfill/console'); /* error will occur if the development tools are not open */
    require('../../polyfill/bind');
    require('../../polyfill/filter');
    require('../../polyfill/map'); // TODO: should be on Raphael import ... is it?*/
}


/*
* Marionette Shim -- this will get it working in Webpack.
* Must require in order.
* */
var _ = require('underscore'),
    Backbone = require('backbone'),
    $ = require('jquery');

Backbone.$ = $; //must be here for webpack
Backbone.Radio = require('backbone.radio');
var Marionette = require('marionette'); // (must be var)


require('jquery.ui.effect'); // ensure its exports applied to jquery
require('./extension/backbone');

/**
 * TODO
 * - require backbone.mousetrap once (or need a view to inherit all others from ( it gets run again and again )
 * - require mousetrap first (and once here)
 * - still?
 * Really Bootstrapping the Mousetrap.prototype.stopCallback
 */
require('./extension/mousetrap');

/* jquery-extension called where used */

require('moment');
require('./extension/moment');


/* Extend Backbone.Radio */
Backbone.Radio.Channel.prototype.triggerMethod = Marionette.triggerMethod;


Marionette.Renderer = {
    render: function(template, data) {
        return _.isFunction(template) ? template(data) : template;
    }
};


var FV = require('./FV');
FV.prototype._src = util.getFileNameFromPath(src); /* store the name of the file on FV prototype: this is used in isolating error messages only from the script */


module.exports = new FV();



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/FV-bootstrap.js
 ** module id = 0
 ** module chunks = 0
 **/